export enum ShopFeatureFlags {
  enableFavorites = 'enableFavorites',
  showShopMaintenancePage = 'showShopMaintenancePage',
  showSapMaintenanceWarning = 'showSAPMaintenanceDialogueOnShop',
  showReturnablePackagingDropdownButton = 'showReturnablePackagingDropdownButton',
}
